import React from 'react';
//import BusinessCard from './BusinessCard';
import { useNavigate } from "react-router-dom";
//import { BusinessCardData } from '../../data/CardData';

const BusinessCardList = () => {
    const Role = sessionStorage.getItem('Role')
    // console.log("abc",Role);

    const navigate = useNavigate()
    const redirectDashboardPage = () => {
        navigate('/dashboard')
    }
    const redirectBusinessDashboard = () => {
        navigate("/businessMyDashboard")
    }

    const redirectbusinessShowAllMeetings = () => {
        navigate("/businessShowAllMeeting")
    }
    const redirectBusinessContact = () => {
        navigate("/contactManagement")
    }
    const redirectBusinessLead = () => {
        navigate("/businessLead")
    }
    const redirectBusinessOpportunity = () => {
        navigate("/businessOpportunity")
    }
    const redirectBusinessCaf = () => {
        navigate("/businessCaf")
    }
    const redirectBusinessSaf = () => {
        navigate("/saf")
    }
    const redirectBusinessNewContact = () => {
        navigate("/newContact")
    }

    const redirectBusinessBdrOfficeContact = () => {
        navigate("/businessBdrOfficeAllContact")
    }

    const redirectBusinessBdrPgContact = () => {
        navigate("/businessBdrPgAllContact")
    }

    return (
        <>
            <div className="container-fluid text-light Header-style header">
                <div className="p-3">
                    <span className='' style={{ cursor: 'pointer' }} onClick={redirectDashboardPage}>
                        <i className="fa-solid fa-arrow-left-long"></i>
                    </span>
                    <span className='p-1 m-3'>Menu</span>
                </div>
            </div>
            <div className="container-fluid Business-main">
                <div className="row row-cols-1 row-cols-sm-1 row-cols-md-2 row-cols-lg-3">
                    {/* {BusinessCardData.map((data, id) => (
                        <div className="col" key={id} onClick={() => redirectBusinessPage(data.path)}>
                            <BusinessCard title={data.title} />
                        </div>
                    ))} */}

                    {Role == "BDR Team" ? (
                        <>
                            <div className="col">
                                <div className="card mb-3 mt-2 shadow-sm" onClick={redirectBusinessNewContact}>
                                    <div className="m-2 " style={{ display: "inline-flex" }}>
                                        <p className="card-text overflow-hidden">Contact Management</p>
                                    </div>
                                </div>
                            </div>

                            {/* <div className="col">
                                <div className="card mb-3 mt-2 shadow-sm" onClick={redirectBusinessBdrOfficeContact}>
                                    <div className="m-2 " style={{ display: "inline-flex" }}>
                                        <p className="card-text overflow-hidden">Office Contact Management</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col">
                                <div className="card mb-3 mt-2 shadow-sm" onClick={redirectBusinessBdrPgContact}>
                                    <div className="m-2 " style={{ display: "inline-flex" }}>
                                        <p className="card-text overflow-hidden">PG Contact Management</p>
                                    </div>
                                </div>
                            </div> */}

                            <div className="col">
                                <div className="card mb-3 mt-2 shadow-sm" onClick={redirectBusinessLead}>
                                    <div className="m-2 " style={{ display: "inline-flex" }}>
                                        <p className="card-text overflow-hidden">Lead</p>
                                    </div>
                                </div>
                            </div>

                        </>
                    ) : (
                        <>
                            <div className="col">
                                <div className="card mb-3 mt-2 shadow-sm" onClick={redirectBusinessDashboard}>
                                    <div className="m-2 " style={{ display: "inline-flex" }}>
                                        <p className="card-text overflow-hidden">My Dashboard</p>
                                    </div>
                                </div>
                            </div>

                            <div className="col">
                                <div className="card mb-3 mt-2 shadow-sm" onClick={redirectbusinessShowAllMeetings}>
                                    <div className="m-2 " style={{ display: "inline-flex" }}>
                                        <p className="card-text overflow-hidden">All Business Meetings</p>
                                    </div>
                                </div>
                            </div>

                            <div className="col">
                                <div className="card mb-3 mt-2 shadow-sm" onClick={redirectBusinessContact}>
                                    <div className="m-2 " style={{ display: "inline-flex" }}>
                                        <p className="card-text overflow-hidden">Contact Management</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col">
                                <div className="card mb-3 mt-2 shadow-sm" onClick={redirectBusinessLead}>
                                    <div className="m-2 " style={{ display: "inline-flex" }}>
                                        <p className="card-text overflow-hidden">Lead</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col">
                                <div className="card mb-3 mt-2 shadow-sm" onClick={redirectBusinessOpportunity}>
                                    <div className="m-2 " style={{ display: "inline-flex" }}>
                                        <p className="card-text overflow-hidden">Opportunity</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col">
                                <div className="card mb-3 mt-2 shadow-sm" onClick={redirectBusinessCaf}>
                                    <div className="m-2 " style={{ display: "inline-flex" }}>
                                        <p className="card-text overflow-hidden">CAF</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col">
                                <div className="card mb-3 mt-2 shadow-sm" onClick={redirectBusinessSaf}>
                                    <div className="m-2 " style={{ display: "inline-flex" }}>
                                        <p className="card-text overflow-hidden">SAF</p>
                                    </div>
                                </div>
                            </div>
                        </>
                    )}
                </div>
            </div>
        </>
    );
}

export default BusinessCardList;
